import {
  ADDITIONAL1024PX_LINK,
  ADDITIONAL1093PX_LINK,
  CALCULATOR_LINK,
  CIANPRO_LINK,
  COMMERCIAL_LINK,
  DEAL_RENT_LINK,
  MORTGAGE_LINK,
  NEWBUILDINGS_LINK,
  RENT_LINK,
  SALE_LINK,
} from '../../../constants/menuLinks';
import { TDealRentLinkExperiment } from '../../../types/experiments';
import { IMenuLink } from '../../../types/menuLink';

interface IGetMenuLinksParams {
  isCianProEnabled: boolean;
  dealRentLinkExperiment: TDealRentLinkExperiment;
}

export const getMenuLinks = (params: IGetMenuLinksParams): IMenuLink[] => {
  const { isCianProEnabled, dealRentLinkExperiment } = params;

  return [
    RENT_LINK,
    SALE_LINK,
    getDealRentLink(dealRentLinkExperiment),
    NEWBUILDINGS_LINK,
    COMMERCIAL_LINK,
    isCianProEnabled ? CIANPRO_LINK : CALCULATOR_LINK,
    MORTGAGE_LINK,
    ADDITIONAL1024PX_LINK,
    ADDITIONAL1093PX_LINK,
  ].filter(Boolean) as IMenuLink[];
};

function getDealRentLink(dealRentLinkExperiment: TDealRentLinkExperiment): IMenuLink | null {
  switch (dealRentLinkExperiment) {
    case 'cianRent':
      return { ...DEAL_RENT_LINK, title: 'Аренда от Циан' };

    case 'dealRent':
      return { ...DEAL_RENT_LINK, title: 'Сдай/Сними' };

    case 'off':
    default:
      return null;
  }
}
